import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Row,Col, Card, Form, Button, } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import axios from 'axios';

import PsContext from '../../context/PsContext';

class ViewProfile extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			count: [],
		}
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'View Profile',
			back: true,
		});
		
	}
	
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	getUserInfo(field){
		try{
			var d = this.context.state.user;
			return d[field];
		}
		catch(er){ }
	}
	
	render(){

		return(
			<div data-aos="fade">
				<div className="container" >
					<div className="profile-wrapper-area py-3">
					
					<div className="card user-info-card">
						<div className="card-body p-4 d-flex align-items-center">
						  <div className="user-profile me-3">
							<img src="img/bg-img/9.jpg" alt=""  />
						  </div>
						  <div className="user-info">
							<p className="mb-0 text-white">@{this.getUserInfo('username')}</p>
							<h5 className="mb-0">{this.getUserInfo('name')}</h5>
						  </div>
						</div>
					  </div>
					  
					   <div className="card user-data-card">
						<div className="card-body">
						  <div className="single-profile-data d-flex align-items-center justify-content-between">
							<div className="title d-flex align-items-center"><i className="lni lni-user"></i><span>Username</span></div>
							<div className="data-content">@{this.getUserInfo('username')}</div>
						  </div>
						  <div className="single-profile-data d-flex align-items-center justify-content-between">
							<div className="title d-flex align-items-center"><i className="lni lni-user"></i><span>Full Name</span></div>
							<div className="data-content">{this.getUserInfo('name')}</div>
						  </div>
						  <div className="single-profile-data d-flex align-items-center justify-content-between">
							<div className="title d-flex align-items-center"><i className="lni lni-phone"></i><span>Phone</span></div>
							<div className="data-content">{this.getUserInfo('mobile')}</div>
						  </div>
						  <div className="single-profile-data d-flex align-items-center justify-content-between">
							<div className="title d-flex align-items-center"><i className="lni lni-envelope"></i><span>Email Address</span></div>
							<div className="data-content">{this.getUserInfo('email')}</div>
						  </div>
						  <div className="single-profile-data d-flex align-items-center justify-content-between">
							<div className="title d-flex align-items-center"><i className="lni lni-map-marker"></i><span>Last Login</span></div>
							<div className="data-content">{this.getUserInfo('last_login')}</div>
						  </div>
						  
						</div>
					  </div>
					  
				</div>
					  
				</div>
			</div>
		);
	}
	
}
export default ViewProfile;
